module.exports = __webpack_public_path__ + "static/taurus-0d952e8f1c2200f70f34816dfb15f5bc.jpg";